export default {
  gift_card_removed: 'Gift card rimossa',
  invalid_gift_card: 'Gift card non valida',
  gift_card_applied: 'Gift card applicata',
};
